import { useState } from 'react';

/**
 * Hook to extract sorting logic for table entries
 * Based on sort direction (ascending or descending), sorts entries in
 * alphabetic based order by comparing strings of sortColumn
 */

type SortDirection = 'ascending' | 'descending';

export default function useTableSort<T>(initialSortColumn = '', initialDirection: SortDirection = 'ascending') {
  const [sortColumn, setSortColumn] = useState(initialSortColumn);
  const [sortDirection, setSortDirection] = useState<SortDirection>(initialDirection);

  const sortData = (data: T[]) => {
    if (!sortColumn) return [...data];

    return [...data].sort((a, b) => {
      const valueA = String(a[sortColumn as keyof T] || '');
      const valueB = String(b[sortColumn as keyof T] || '');

      return sortDirection === 'ascending' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
    });
  };

  const onSort = ({
    sortColumn: newSortColumn,
    sortDirection: newSortDirection,
  }: {
    sortColumn: string;
    sortDirection: SortDirection;
  }) => {
    setSortDirection(newSortDirection);
    setSortColumn(newSortColumn);
  };

  return {
    sortColumn,
    sortDirection,
    onSort,
    sortData,
  };
}
